import { render, staticRenderFns } from "./lisaa-suorite.vue?vue&type=template&id=b8272bce&scoped=true&"
import script from "./lisaa-suorite.vue?vue&type=script&lang=ts&"
export * from "./lisaa-suorite.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-suorite.vue?vue&type=style&index=0&id=b8272bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8272bce",
  null
  
)

export default component.exports